<template>
    <q-dialog v-model="visible">
        <q-card class="bg-white" style="min-width: 800px;">
            <q-card-section>
                <div class="text-h6 text-center">Wellbeing Issues Breakdown: {{ label }}</div>
            </q-card-section>

            <q-tabs v-model="tab" dense class="text-primary" active-color="primary" indicator-color="primary"
                align="justify" narrow-indicator>
                <q-tab name="table" no-caps label="Issues Table" />
                <q-tab name="info" no-caps label="Wellbeing Info" />
            </q-tabs>

            <q-tab-panels v-model="tab" animated>
                <q-tab-panel name="table" class="q-pa-sm">
                    <p class="q-mt-md text-center"><strong>Note:</strong> The filters from the previous page are applied to the table.</p>
                    <q-table :rows="wellbeingBreakdownData" :columns="wellbeingColumns" row-key="issue_id" flat dense
                        :pagination="{ rowsPerPage: 10 }" no-data-label="No issues found" :loading="loadingBreakdown" />
                </q-tab-panel>

                <q-tab-panel name="info" class="q-pa-md">
                    <div>
                        <p><strong>Purapura Whetu: Six Areas of Wellbeing</strong></p>
                        <ul>
                            <li><strong>Ukaipo</strong></li>
                            <li><strong>Hinengaro</strong></li>
                            <li><strong>Tinana</strong></li>
                            <li><strong>Taiao</strong></li>
                            <li><strong>Rawa</strong></li>
                            <li><strong>Wairua</strong></li>
                        </ul>

                        <p><strong>Grouping Issues in Te Kohinga</strong></p>
                        <p>
                            After retrieving the client's reason for referral, <strong>Te Kohinga</strong> maps issues
                            to one or more relevant areas of wellbeing.
                        </p>
                        <ul>
                            <li>Issues can belong to <strong>multiple wellbeing areas</strong> (e.g., <em>abuse</em> may relate to both <strong>Tinana</strong> and <strong>Hinengaro</strong>).</li>
                            <li>Each mapping is assigned a <strong>priority</strong> (e.g., priority 1 = most relevant).</li>
                            <li>You can toggle between two views of the wellbeing breakdown:
                                <ul>
                                    <li><strong>Significant view</strong>: shows each issue under its <strong>most relevant</strong> wellbeing area (priority 1 only).</li>
                                    <li><strong>Relevant view</strong>: shows each issue under <strong>all wellbeing areas</strong> it is linked to, regardless of priority.</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </q-tab-panel>
            </q-tab-panels>
        </q-card>
    </q-dialog>
</template>

<script>
import api from "@/services/api/api";
import notify from '@/services/util/notify';

export default {
    name: 'WellbeingBreakdownDialog',

    props: {
        label: { type: String, required: true },
        query: { type: String, required: true },
        type: { type: String, default: 'significant' }
    },

    data() {
        return {
            visible: false,
            tab: 'table',
            wellbeingColumns: [
                { name: 'issue_id', label: 'Issue', field: 'issue_id', align: 'left', sortable: true },
                { name: 'count', label: 'Count', field: 'count', align: 'right', sortable: true },
            ],
            wellbeingBreakdownData: [],
            loadingBreakdown: false
        };
    },

    created() {
        this.visible = true;
        this.fetchBreakdown();
    },

    watch: {
        visible(val) {
            if (!val) {
                this.$emit('close');
            }
        }
    },

    methods: {
        async fetchBreakdown() {
            this.loadingBreakdown = true;
            try {
                const response = await api.wellbeing.wellbeingBreakdown(this.label, this.type, this.query);
                this.wellbeingBreakdownData = response.data;
            } catch (err) {
                console.error(err);
                notify.warning("Failed to load wellbeing breakdown data.");
            } finally {
                this.loadingBreakdown = false;
            }
        }
    }
};
</script>
